import React from "react";

import TicketListItem from "../../components/TicketListItem";
import ChatListEmptyState from "./ChatListEmptyState";
import ChatTailwickListSkeleton from "./ChatTailwickListSkeleton";
import ChatListSection, { getTailwickListSections } from "./ChatListSection";
import { i18n } from "../../translate/i18n";
import TicketBulkActionsButtons from "../../components/TicketBulkActionsButtons";
import apiv2 from "../../services/apiV2";

function renderTickets(
	tickets,
	updateCount,
	bulkSelection,
	bulkSelected,
	setBulkSelected
) {
	return tickets.map((ticket) => (
		<TicketListItem
			key={ticket.id}
			ticket={ticket}
			updateCount={updateCount}
			relatedTickets={ticket.relatedTickets}
			tailwickLayout
			bulkSelection={bulkSelection}
			bulkSelected={bulkSelected}
			setBulkSelected={setBulkSelected}
		/>
	));
}

/**
 * Lista de conversas Tailwick — scroll + seções como Chats.tsx.
 */
export default function TailwickTicketsListView({
	tickets,
	status,
	loading,
	final,
	loadMore,
	onScroll,
	updateCount,
	bulkSelection,
	setBulkSelection,
	bulkSelected = [],
	setBulkSelected,
	queueIds = [],
	tagsIds = [],
	channels = [],
	companyId,
	canSeeAllTickets,
	sortBy,
	reload
}) {
	const sections = getTailwickListSections(tickets, status);
	const isEmpty = tickets.length === 0 && !loading;

	function MarcaTodos(e) {
		const checkboxes = document.querySelectorAll('input[type="checkbox"][name="bulkSelected"]');
		let selectedCount = 0;

		if (e.target.checked) {
			if (checkboxes.length > 50) {
				selectedCount = 50
			}else{
				selectedCount = checkboxes.length
				apiv2.get('/ticket-ids', {
					params: {
						status,
						companyId,
						canSeeAllTickets : canSeeAllTickets ? 1 : 0,
						queues: queueIds.length > 0 ? queueIds.join(',') : undefined,
						tagsIds: tagsIds.length > 0 ? tagsIds.join(',') : undefined,
						channel: channels.length > 0 ? channels.join(',') : undefined,
						sortBy : sortBy,
					},
				})
				.then((response) => {

					setBulkSelected((selecionados) => {
						const idsExistentes = new Set(selecionados);

						const itensParaAdicionar = response.data.ids.filter(
							item => !idsExistentes.has(item)
						);
						return [...idsExistentes, ...itensParaAdicionar].slice(0, 50);
					});

				})
			}
		} else {
			setBulkSelected([]);
		}

		for (let i = 0; i < selectedCount; i++) {
			let checkbox = checkboxes[i];
			if (checkbox.checked !== e.target.checked) {
				checkbox.checked = e.target.checked;
			}
		}
	}

	return (
		<>
		{bulkSelection && (
			<>
				<div style={{ display: "flex", justifyContent:"space-between", alignItems: "center", gap: "0.5rem", padding: "0.5rem" }}>
					<div>Selecionados: {bulkSelected.length}/50</div>
					<TicketBulkActionsButtons
						bulkSelected={bulkSelected}
						setBulkSelection={setBulkSelection}
						ticketStatus={status}
						onTicketUpdated={(updatedTickets) => {
							updatedTickets.forEach((updatedTicket) => {
								const index = tickets.findIndex((ticket) => ticket.id === updatedTicket.id);
								if (index !== -1) {
									tickets[index] = updatedTicket;
								}
								setBulkSelected([]);
							});
						}}
						reload={reload}
					/>
				</div>
				<div style={{ display: "flex", justifyContent:"flex-start", alignItems: "center", gap: "0.5rem", paddingLeft: "1rem" }}>
				<input
					type="checkbox"
					style={{transform: "scale(1.6)",padding: "0.5rem"}}
					onClick={MarcaTodos}
				/>
				</div>
				</>
			)}
		<div className="tailwick-chats-scroll flex min-h-0 flex-1 flex-col overflow-hidden">
			<div className="tailwick-chats-list-inner min-h-0 flex-1 overflow-y-auto" onScroll={onScroll}>
				{isEmpty ? (
					<ChatListEmptyState />
				) : (
					<>
						<ChatListSection label={sections.primaryLabel} />
						{renderTickets(sections.primaryTickets, updateCount, bulkSelection, bulkSelected, setBulkSelected)}

						{sections.secondaryTickets.length > 0 && (
							<>
								<ChatListSection label={sections.secondaryLabel} />
								<div className="pt-2">{renderTickets(sections.secondaryTickets, updateCount, bulkSelection, bulkSelected, setBulkSelected)}</div>
							</>
						)}
					</>
				)}
				{loading && <ChatTailwickListSkeleton />}
			</div>

			{final && !isEmpty && (
				<div className="shrink-0 border-t border-default-200 px-4 py-3">
					<button
						type="button"
						className="btn w-full bg-default-150 text-sm text-default-600 hover:bg-default-200 disabled:opacity-70"
						onClick={loadMore}
						disabled={loading}
					>
						{loading ? (
							<span className="inline-flex items-center gap-2">
								<span className="size-3.5 animate-spin rounded-full border-2 border-default-400 border-t-transparent" />
								{i18n.t("chat.layout.loadingMore")}
							</span>
						) : (
							i18n.t("chat.layout.loadMore")
						)}
					</button>
				</div>
			)}
		</div>
		</>
	);
}
